// Компонент выпадающего списка с tooltip

import type { SelectFieldProps } from '../../types';
import { HelpCircle } from 'lucide-react';
import './Input.css';

interface ExtendedSelectFieldProps<T extends string> extends SelectFieldProps<T> {
  tooltip?: string;
  required?: boolean;
  hint?: string;
}

export function SelectField<T extends string>({
  label,
  value,
  onChange,
  options,
  disabled = false,
  tooltip,
  required = false,
  hint,
}: ExtendedSelectFieldProps<T>) {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value as T);
  };

  return (
    <div className="input-group">
      <label className={`input-group__label ${required ? 'input-group__label--required' : ''}`}>
        {label}
        {tooltip && (
          <span className="tooltip input-group__tooltip">
            <HelpCircle className="tooltip__trigger" size={16} />
            <span className="tooltip__content">{tooltip}</span>
          </span>
        )}
      </label>
      <select
        className="select"
        value={value}
        onChange={handleChange}
        disabled={disabled}
        aria-describedby={hint ? `${label}-hint` : undefined}
      >
        {options.map((option) => (
          <option key={String(option.value)} value={String(option.value)}>
            {option.label}
          </option>
        ))}
      </select>
      {hint && (
        <span className="input-group__hint" id={`${label}-hint`}>{hint}</span>
      )}
    </div>
  );
}
